import { GLOBAL_CONSTANTS } from '../global/constants';
import { removeURLParameter, historyPushState } from './url';
import { getCookie } from './browser';

const md5 = require('md5');

export function capitalizeString(name) {
  if (!name) return name;
  return name.replace(/\b\w/g, l => l.toUpperCase())
}

export function formatDisplay(input, format) {
  if (!input || !format) return input;
  let result = "", formats = format.split(" "), start = 0, end = 0;
  for (let i = 0; i < formats.length; i++) {
    end = start + formats[i].length;
    result += input.substring(start, end) + (i !== formats.length - 1 ? " " : "");
    start = end;
  };
  result += input.substring(start);

  return result;
}

export function replaceVariable(source = "", variable = {}) {
  let result = source;
  for (let [key, value] of Object.entries(variable)) {
    if (value && typeof value === "string" && value.includes("$")) {
      value = value.replaceAll("$", "&#36;")
    }
    result = result.replaceAll(`{{${key}}}`, value);
  }
  return result;
}

export function reverse(s) {
  return [...s].reverse().join("");
}

export function validateISO8859(s) {
  // eslint-disable-next-line
  return !/[^\u0000-\u00ff]/g.test(s);
}

export function formatText(s) {
  let result = s;
  if (result && typeof (result) === "string") {
    result = result.trim().replace(/\n/g, "")
  }
  return result;
}

export function genCKS(uid, code, secure = false) {
  if (secure) {
    const result = md5(reverse(`${uid}secure${code}`));
    return `${result.slice(6, 8)}${reverse(result.slice(0, 6))}${result.slice(8, 11)}`;
  }
  return md5(reverse(`${uid}${code}`)).slice(0, 10);
}

export function validateChecksum(uid, code, sku, hideUrlParam = false) {
  const result = !uid || genCKS(uid, code) === sku || genCKS(uid, code, true) === sku;
  if (hideUrlParam && result && uid && uid === getCookie(GLOBAL_CONSTANTS.UID)) {
    historyPushState(removeURLParameter(removeURLParameter(window.location.href, GLOBAL_CONSTANTS.UID), GLOBAL_CONSTANTS.CHECKSUM), true);
  }
  return result;
}

window.genCKS = genCKS;

export function arrayToString(arr) {
  var result = "";
  arr.forEach(element => {
    result += element
  });
  return result;
}


/* eslint-disable no-extend-native */
String.prototype.asciifolding = function () {
  var from = "àáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñçýỳỹỵỷ",
    to = "aaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouuncyyyyy";
  var str = this.toLowerCase().trim()
  for (var i = 0, l = from.length; i < l; i++) { str = str.replace(RegExp(from[i], "gi"), to[i]); }
  return str;
}
String.prototype.ngram_hightlight = function (sentence, options) {
  if (sentence.trim() === "") {
    return this + "";
  }
  if (!options) {
    options = {}
  }
  if (!options.pre_tag) {
    options.pre_tag = '<pre>';
  }
  if (!options.post_tag) {
    options.post_tag = '</pre>';
  }
  var asciifoldingTxt = this.asciifolding();
  var replacements = [];
  var words = sentence.split(" ");
  var compared = {};
  for (let idx in words) {
    var t = asciifoldingTxt;
    var word = words[idx];
    if (word.trim() === "") {
      continue;
    }
    var asciifoldingWord = word.asciifolding();
    if (compared[asciifoldingWord]) {
      continue;
    }
    compared[asciifoldingWord] = true;
    var asciifoldingWordLen = asciifoldingWord.length;
    var startPos = 0;
    while (true) {
      var pos = t.indexOf(asciifoldingWord);
      if (pos === -1) {
        break
      }
      replacements.push({ pos: startPos + pos, len: asciifoldingWordLen });
      t = t.substr(pos + asciifoldingWordLen);
      startPos = startPos + pos + asciifoldingWordLen;
    }
  }
  replacements = replacements.sort(function (a, b) { return (a.pos > b.pos) ? 1 : ((b.pos > a.pos) ? -1 : 0) })
  var selectedReplacements = {};
  var selectedPos = [];
  var replacementsLen = replacements.length;
  for (let i = 0; i < replacementsLen; i++) {
    var currentReplacement = replacements[i];
    var startI = i;
    for (let j = i + 1; j < replacementsLen; j++) {
      if (currentReplacement.pos === replacements[j].pos) {
        if (currentReplacement.len <= replacements[j].len) {
          currentReplacement = replacements[j];
        }
        startI = startI + 1;
      } else if (currentReplacement.pos < replacements[j].pos && replacements[j].pos <= (currentReplacement.pos + currentReplacement.len)) {
        startI = startI + 1;
        continue;
      } else {
        break;
      }
    }
    selectedReplacements[currentReplacement.pos] = currentReplacement;
    selectedPos.push(currentReplacement.pos);
    i = startI;
  }
  let result = this + "";
  for (let i = selectedPos.length - 1; 0 <= i; i--) {
    var replacement = selectedReplacements[selectedPos[i]];
    result = result.substr(0, replacement.pos) + options.pre_tag + result.substr(replacement.pos, replacement.len) + options.post_tag + result.substr(replacement.pos + replacement.len);
  }
  return result;
}
String.prototype.word_hightlight = function (sentence, options) {
  if (sentence.trim() === "") {
    return this + "";
  }
  if (!options) {
    options = {}
  }
  if (!options.pre_tag) {
    options.pre_tag = '<pre>';
  }
  if (!options.post_tag) {
    options.post_tag = '</pre>';
  }
  var tWords = this.split(" ");
  var words = sentence.split(" ");
  for (var idx in words) {
    var word = words[idx];
    if (word.trim() === "") {
      continue;
    }
    var asciifoldingWord = word.asciifolding();
    for (var i in tWords) {
      if (tWords[i] !== "" && tWords[i].asciifolding() === asciifoldingWord) {
        tWords[i] = options.pre_tag + tWords[i] + options.post_tag;
      }
    }
  }
  var result = "";
  for (let i in tWords) {
    result = result + tWords[i] + " ";
  }
  return result;
}

export function addHighlightText(element, keyword, color) {
  const c = { "à": "a", "á": "a", "ã": "a", "ả": "a", "ạ": "a", "ă": "a", "ằ": "a", "ắ": "a", "ẳ": "a", "ẵ": "a", "ặ": "a", "â": "a", "ầ": "a", "ấ": "a", "ẩ": "a", "ẫ": "a", "ậ": "a", "è": "e", "é": "e", "ẻ": "e", "ẽ": "e", "ẹ": "e", "ê": "e", "ề": "e", "ế": "e", "ể": "e", "ễ": "e", "ệ": "e", "đ": "d", "ù": "u", "ú": "u", "ủ": "u", "ũ": "u", "ụ": "u", "ư": "u", "ừ": "u", "ứ": "u", "ử": "u", "ữ": "u", "ự": "u", "ò": "o", "ó": "o", "ỏ": "o", "õ": "o", "ọ": "o", "ô": "o", "ồ": "o", "ố": "o", "ổ": "o", "ỗ": "o", "ộ": "o", "ơ": "o", "ờ": "o", "ớ": "o", "ở": "o", "ỡ": "o", "ợ": "o", "ì": "i", "í": "i", "ỉ": "i", "ĩ": "i", "ị": "i", "ä": "a", "ë": "e", "ï": "i", "î": "i", "ö": "o", "ü": "u", "û": "u", "ñ": "n", "ç": "c", "ý": "y", "ỳ": "y", "ỹ": "y", "ỵ": "y", "ỷ": "y" }
  element.mark(keyword,
    {
      "separateWordSearch": true,
      "diacritics": true,
      "synonyms": c,
      "element": "span",
      "className": "highlight-text"
    }
  );
  element.find(".highlight-text").css("color", color || "#F37234");
}

export function stripHtml(html, maxLength) {
  let tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  let result = tmp.textContent || tmp.innerText || "";
  return maxLength ? result.substring(0, maxLength) : result;
}

export function addSlashes(str) {
  return (str ?? "").replace(/&/g, '&amp;') /* This MUST be the 1st replacement. */
    .replace(/'/g, '&apos;') /* The 4 other predefined entities, required. */
    .replace(/"/g, '&quot;')
    .replace(/\\/g, '\\\\')
    .replace(/</g, '&lt;')
    // eslint-disable-next-line no-control-regex
    .replace(/>/g, '&gt;').replace(/\u0000/g, '\\0');
}